import React from 'react';
import { HelpCircleIcon, SearchIcon, BookOpenIcon, GitCompareIcon, TimerIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { clinicalDoubts } from '../../data/content';
const timeWasters = [{
  icon: BookOpenIcon,
  label: 'Abrir varias guías'
}, {
  icon: SearchIcon,
  label: 'Buscar recomendaciones'
}, {
  icon: GitCompareIcon,
  label: 'Comparar algoritmos'
}, {
  icon: TimerIcon,
  label: 'Perder tiempo valioso'
}];
export function Problem() {
  return <Section tone="cream" data-id="element-261" data-mp="2cpl08fqaitjv">
      <Eyebrow data-id="element-262" data-mp="2cth2cuktrz3z">El verdadero problema</Eyebrow>
      <Heading data-id="element-263" data-mp="28qkfgro95gu8">
        ¿Cuánto tiempo dedicas cada semana a resolver una decisión que debería tomarte solo unos{' '}
        <span className="italic text-brand" data-id="element-264" data-mp="23s0vuxx4sh51">minutos</span>?
      </Heading>

      <div className="mx-auto mt-6 max-w-xl space-y-4 text-[15px] leading-relaxed text-navy/75 sm:text-[17px]" data-id="element-265" data-mp="6x4pzy3wi80u">
        <p className="text-center font-serif text-lg font-bold italic text-navy sm:text-2xl" data-id="element-266" data-mp="20e9j9o6paew">
          Porque el verdadero problema no es la diabetes.
        </p>
        <p data-id="element-267" data-mp="19aodclvq1tur">
          El verdadero problema es que cada paciente llega con una combinación diferente de
          comorbilidades, tratamientos previos y factores de riesgo, obligándote a tomar decisiones
          importantes bajo presión y con poco tiempo.
        </p>
      </div>

      <p className="mt-8 text-center text-[13px] font-extrabold uppercase tracking-[0.14em] text-navy/50" data-id="element-268" data-mp="1nz1bnpia7osf">
        Y entonces aparecen preguntas como:
      </p>

      <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-269" data-mp="1s04tuinsxwwt">
        {clinicalDoubts.map(doubt => <li key={doubt} className="flex items-start gap-2.5 rounded-2xl border border-navy/10 bg-white px-3.5 py-3" data-id="element-270" data-mp="1e8q65yiy97jf">
            <HelpCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-bad" aria-hidden="true" data-id="element-271" data-mp="26xdnjj0kvcrp" />
            <span className="text-[14px] font-semibold leading-snug text-navy sm:text-[15px]" data-id="element-272" data-mp="2bodlmrlfo0vs">
              {doubt}
            </span>
          </li>)}
      </ul>

      <p className="mt-9 text-center font-serif text-[19px] font-bold leading-snug text-navy sm:text-2xl" data-id="element-273" data-mp="2li9nsqmjq804">
        Cuando eso ocurre, muchos médicos terminan haciendo lo mismo.
      </p>

      <ol className="mt-5 grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-id="element-274" data-mp="2bkljb8z51m4r">
        {timeWasters.map(({
        icon: Icon,
        label
      }, i) => <li key={label} className="flex flex-col items-center gap-2 rounded-2xl border border-navy/10 bg-cream-dark px-2 py-4 text-center" data-id="element-275" data-mp="22lrqltoxhfwh" data-mpi={i}>
            <Icon className="h-5 w-5 text-navy/45" aria-hidden="true" data-id="element-276" data-mp="1xsyjx09wfxhr" />
            <span className="text-[12.5px] font-bold leading-tight text-navy/70" data-id="element-277" data-mp="1swghi721kb8l">
              {i + 1}. {label}
            </span>
          </li>)}
      </ol>

      <p className="mx-auto mt-6 max-w-lg text-center text-[15px] leading-relaxed text-navy/70" data-id="element-278" data-mp="1iyajw1n9pr9j">
        Y perder un tiempo valioso mientras el paciente espera una respuesta.
      </p>

      <SectionCTA promise="Deja de resolver cada consulta desde cero. Empieza a decidir con un sistema." label="Quiero decidir sin dudar" data-id="element-279" data-mp="3qjsp9qzaa5qm" />
    </Section>;
}